import { API } from "@/constants/api";
import { API_BASE_URL, AxiosUtil } from "@/Utils/axios.util";
import { AxiosResponse } from "axios";

const manualChargesUrl = process.env.NODE_ENV === "development"
    ? `${API_BASE_URL}/api/admin/manual-charges`
    : API.panel.manualCharges.list;

// sayyarpay
async function GetTotalUsers(): Promise<AxiosResponse> {
    const url = API.panel.getTotalUsers;
    return AxiosUtil.post(url);
}

async function GetDashboardStats(): Promise<AxiosResponse> {
    return AxiosUtil.post(API.panel.getDashboardStats);
}

async function GetTotalTransactions(): Promise<AxiosResponse> {
    const url = API.panel.getTotalTransactions;
    return AxiosUtil.post(url);
}

async function GetTotalCommisions(): Promise<AxiosResponse> {
    const url = API.panel.getTotalCommisions;
    return AxiosUtil.post(url);
}

async function GetTotalWallets(): Promise<AxiosResponse> {
    const url = API.panel.getTotalWallets;
    return AxiosUtil.post(url);
}

async function GetAllUsers(
    type?: string,
    filters?: { email?: string; phone?: string; name?: string },
    page = 1,
    limit = 50,
): Promise<AxiosResponse> {
    const url = API.panel.getAllUsers;
    const body = {
        type: type || 'all',
        filters: filters || {}
    }
    return AxiosUtil.post(url, body, { params: { page, limit } });
}

async function SearchUser(phone?: string, name?: string, email?: string): Promise<AxiosResponse> {
    const url = API.panel.searchUser;
    const params = new URLSearchParams();

    if (phone) params.append('phone', phone);
    if (name) params.append('name', name);
    if (email) params.append('email', '0098' + email.slice(1));

    // url.search = params.toString(); // Append query parameters to URL
    console.log("params ===>", params);
    return AxiosUtil.post(url.toString(), {});
}

async function GetNotVerifiedUsers(page = 1, limit = 50): Promise<AxiosResponse> {
    const url = API.panel.getNotVerifiedUsers;
    return AxiosUtil.post(url, { page, limit });
}

async function GetSystemLogs(): Promise<AxiosResponse> {
    const url = API.panel.getSystemLogs;
    return AxiosUtil.get(url);
}

async function GetUserFinancialLogs(userId: string): Promise<AxiosResponse> {
    const url = API.panel.getUserFinancialLogs;
    return AxiosUtil.get(url, {
        headers: {
            user: userId
        }
    });
}

// async function GetFinancialLogs

async function GetExternalTransactions(query: any = {}): Promise<AxiosResponse> {
    const url = API.panel.getFullTransactiosReport;

    // Build params: only include defined values
    const params: any = {};

    if (query.page !== undefined) params.page = query.page;
    if (query.startDate !== undefined) params.startDate = query.startDate;
    if (query.endDate !== undefined) params.endDate = query.endDate;
    if (query.type !== undefined) params.type = query.type;
    if (query.typeTool !== undefined) params.typeTool = query.typeTool;
    if (query.status !== undefined) params.status = query.status;

    // Pass as `params`, not body
    return AxiosUtil.get(url, { params });
}

async function GetUserTransactions(userId: string): Promise<AxiosResponse> {
    const url = API.panel.getUserTransactions;
    const body = {
        userId: userId
    }
    return AxiosUtil.post(url, body);
}

async function GetUserExternalTransactions(userId: string): Promise<AxiosResponse> {
    const url = API.panel.getUserExternalTransactions + '/' + userId;
    return AxiosUtil.get(url);
}

async function getAllWithdrawals(): Promise<AxiosResponse> {
    const url = API.panel.getAllWithdrawals;
    return AxiosUtil.get(url);
}

async function GetUserWithdrawals(userId: string): Promise<AxiosResponse> {
    const url = API.panel.getUserWithdrawals + '/' + userId;
    return AxiosUtil.get(url);
}

async function ChargeUserWallet(chargeData: { userId: string, amount: number }): Promise<AxiosResponse> {
    const url = API.panel.chargeUserWallet;
    const body = {
        id: chargeData.userId,
        amount: chargeData.amount
    }
    return AxiosUtil.put(url, body);
}

async function DechargeUserWallet(dechargeData: { userId: string, amount: number }): Promise<AxiosResponse> {
    const url = API.panel.dechargeUserWallet;
    const body = {
        id: dechargeData.userId,
        amount: dechargeData.amount
    }
    return AxiosUtil.put(url, body);
}

async function GetUserInfo(userId: string): Promise<AxiosResponse> {
    const url = API.panel.getUserInfo + '/' + userId;
    return AxiosUtil.get(url);
}

async function GetUserAcceptedAuth(userId: string): Promise<AxiosResponse> {
    const url = API.panel.getUserAcceptedAuth + '/' + userId;
    return AxiosUtil.get(url);
}

async function AcceptUserIdentify(userId: string): Promise<AxiosResponse> {
    const url = API.panel.acceptUserIdentify + '/' + userId;
    return AxiosUtil.put(url);
}

async function RejectUserIdentify(rejectData: { userId: string, message: string }): Promise<AxiosResponse> {
    const url = API.panel.rejectUserIdentify + '/' + rejectData.userId;
    const body = {
        message: rejectData.message
    }
    return AxiosUtil.put(url, body);
}

async function GetSystemSettings(): Promise<AxiosResponse> {
    const url = API.panel.getSettingsSystem;
    return AxiosUtil.get(url);
}

async function SendSystemSettingEdit(settingId: string, systemSetting: Array<{ field: string; value: unknown }>): Promise<AxiosResponse> {
    const url = API.panel.editSystemSetting + '/' + settingId;
    const body = {
        list: systemSetting
    }
    return AxiosUtil.put(url, body);
}

async function GetPaymentSettings(): Promise<AxiosResponse> {
    const url = API.panel.getPaymentSetting;
    return AxiosUtil.get(url);
}

async function UpdatePaymentSettings(form: any): Promise<AxiosResponse> {
    const url = API.panel.updatePaymentSetting;
    return AxiosUtil.post(url, form);
}

async function GetGateways(type?: string): Promise<AxiosResponse> {
    const url = API.panel.getGateways;
    return AxiosUtil.get(url, {
        headers: {
            status: type || 'APPROVED'
        }
    });
}

async function GetGatewayInfo(gateWayId: string): Promise<AxiosResponse> {
    const url = API.panel.getGatewayInfo + "/" + gateWayId;
    return AxiosUtil.get(url);
}

async function GetGateWayTransactions(gatewayId: string): Promise<AxiosResponse> {
    const url = API.panel.getGatewayTransactions + '/' + gatewayId;
    return AxiosUtil.get(url)
}

async function GetCommissions(): Promise<AxiosResponse> {
    const url = API.panel.getCommissions;
    return AxiosUtil.get(url);
}

async function GetDepositTransferHistory(): Promise<AxiosResponse> {
    const url = API.panel.getDepositTransferHistory;
    return AxiosUtil.get(url);
}

async function ToggleGatewayStatus(toggleGatewayData: { gatewayId: string, status: string, rejectMessage?: string }): Promise<AxiosResponse> {
    const url = API.panel.toggleGatewayStatus + '/' + toggleGatewayData.gatewayId;
    const body = {
        status: toggleGatewayData.status,
        rejectMessage: toggleGatewayData.status === 'REJECTED' ? toggleGatewayData.rejectMessage : ''
    };
    return AxiosUtil.put(url, body);
}

async function GetGatewaySettlementSettings(gatewayId: string): Promise<AxiosResponse> {
    const url = API.panel.getGatewaySettlementSettings + '/' + gatewayId;
    return AxiosUtil.get(url);
}

async function UpdateGatewaySettlementSettings(gatewayId: string, payload: Record<string, unknown>): Promise<AxiosResponse> {
    const url = API.panel.updateGatewaySettlementSettings + '/' + gatewayId;
    const body = { ...payload };
    return AxiosUtil.put(url, body);
}

async function GetManualCharges(params?: { status?: string; chargeType?: string; page?: number; pageSize?: number }): Promise<AxiosResponse> {
    const url = manualChargesUrl;
    const queryParams: Record<string, unknown> = {};

    const status = params?.status?.trim();
    if (status && status.toUpperCase() !== "ALL") {
        queryParams.status = status.toUpperCase();
    }

    const chargeType = params?.chargeType?.trim();
    if (chargeType && chargeType.toUpperCase() !== "ALL") {
        queryParams.chargeType = chargeType.toUpperCase();
    }

    if (params?.page && params.page > 0) {
        queryParams.page = params.page;
    }

    if (params?.pageSize && params.pageSize > 0) {
        queryParams.pageSize = params.pageSize;
    }

    return AxiosUtil.get(url, { params: queryParams });
}

async function ApproveManualCharge(manualChargeId: string, amount?: number): Promise<AxiosResponse> {
    const url = `${manualChargesUrl}/${manualChargeId}/approve`;
    const body = amount !== undefined ? { amount } : {};
    return AxiosUtil.post(url, body);
}

async function RejectManualCharge(manualChargeId: string): Promise<AxiosResponse> {
    const url = `${manualChargesUrl}/${manualChargeId}/reject`;
    return AxiosUtil.post(url);
}

async function CreateCryptoManualCharge(payload: Record<string, unknown>): Promise<AxiosResponse> {
    const url = `${manualChargesUrl}/crypto`;
    return AxiosUtil.post(url, payload);
}

async function GetWithdrawalsCrypto(): Promise<AxiosResponse> {
    const url = API.panel.GetWithdrawalsCrypto;
    return AxiosUtil.get(url);
}

async function GetAcceptedWithdrawalsCrypto(): Promise<AxiosResponse> {
    const url = API.panel.GetAcceptedWithdrawalsCrypto;
    return AxiosUtil.get(url);
}

async function GetRejectedWithdrawalsCrypto(): Promise<AxiosResponse> {
    const url = API.panel.GetRejectedWithdrawalsCrypto;
    return AxiosUtil.get(url);
}

async function GetManualChargeStats(): Promise<AxiosResponse> {
    const url = `${manualChargesUrl}/stats`;
    return AxiosUtil.get(url);
}

async function AcceptUsdtCharge(chargeData: { id: string, user: string, usdt: number, link: string }): Promise<AxiosResponse> {
    const url = API.panel.acceptUsdtCharge;
    const data = chargeData;
    return AxiosUtil.post(url, data);
}

async function RejectUsdtCharge(deChargeData: { id: string, user: string, usdt: number, message: string }): Promise<AxiosResponse> {
    const url = API.panel.acceptUsdtCharge;
    const data = deChargeData;
    return AxiosUtil.post(url, data);
}

async function SendUserNotificationRequest(notificationData: { type: string, message: string, desc: string, user: string, metadata: any }): Promise<AxiosResponse> {
    const url = API.panel.sendUserNotification;
    const data = {
        message: notificationData.message,
        type: notificationData.type,
        desc: notificationData.desc,
        userId: notificationData.user,
        metadata: notificationData.metadata
    }

    return AxiosUtil.post(url, data);
}

async function SendNotificationRequest(notificationData: { type: string, message: string }): Promise<AxiosResponse> {
    const url = API.panel.sendGroupNotofication + '/' + notificationData.type;
    const data = {
        desc: notificationData.message
    }
    return AxiosUtil.post(url, data);
}

async function GetExchangeSettings(): Promise<AxiosResponse> {
    const url = API.panel.getExchangeSetting;
    return AxiosUtil.get(url);
}

async function EditExchangeSetting(settingId: string, setting: any): Promise<AxiosResponse> {
    const url = API.panel.updateExchangeSetting;
    const body = setting;
    return AxiosUtil.post(url, body, {
        headers: {
            settingid: settingId
        }
    });
}

async function getTransactionReportExcel(query: any = {}) {
    const url = API.panel.getTransactionsReportExcel;

    const params: any = {};

    if (query.page !== undefined) params.page = query.page;
    if (query.startDate !== undefined) params.startDate = query.startDate;
    if (query.endDate !== undefined) params.endDate = query.endDate;
    if (query.type !== undefined) params.type = query.type;
    if (query.typeTool !== undefined) params.typeTool = query.typeTool;
    if (query.status !== undefined) params.status = query.status;

    return AxiosUtil.get(url, { params });
}

// async function GenerateUserLogin(refId: string): Promise<AxiosResponse> {
//     const url = API.panel.generateUserLogin;
//     const body = {
//         refId: refId
//     }
//     return AxiosUtil.post(url, body);
// }

// async function SendSystemSettingEdit(settingId: string, systemSetting: Array<{ field: string; value: unknown }>): Promise<AxiosResponse> {
//     const url = API.panel.editSystemSetting + '/' + settingId;
//     const body = {
//         list: systemSetting
//     }
//     return AxiosUtil.put(url, body);
// }

export const panelRequests = {
    // sayyarpay
    GetTotalUsers,
    GetDashboardStats,
    GetTotalTransactions,
    GetTotalCommisions,
    GetTotalWallets,
    GetAllUsers,
    SearchUser,
    GetNotVerifiedUsers,
    GetSystemLogs,
    GetUserFinancialLogs,
    GetExternalTransactions,
    GetUserTransactions,
    GetUserExternalTransactions,
    getAllWithdrawals,
    GetUserWithdrawals,
    ChargeUserWallet,
    DechargeUserWallet,
    GetUserInfo,
    GetUserAcceptedAuth,
    AcceptUserIdentify,
    RejectUserIdentify,
    GetSystemSettings,
    SendSystemSettingEdit,
    GetPaymentSettings,
    UpdatePaymentSettings,
    GetGateways,
    GetGatewayInfo,
    GetGateWayTransactions,
    GetCommissions,
    GetDepositTransferHistory,
    ToggleGatewayStatus,
    GetGatewaySettlementSettings,
    UpdateGatewaySettlementSettings,
    GetManualCharges,
    ApproveManualCharge,
    RejectManualCharge,
    CreateCryptoManualCharge,
    GetWithdrawalsCrypto,
    GetAcceptedWithdrawalsCrypto,
    GetRejectedWithdrawalsCrypto,
    GetManualChargeStats,
    AcceptUsdtCharge,
    RejectUsdtCharge,
    SendUserNotificationRequest,
    SendNotificationRequest,
    GetExchangeSettings,
    EditExchangeSetting,
    getTransactionReportExcel
};
